/// <amd-module name="Tfs/Platform/MyWorkFlyout" />
import React = require("react");
import { IReadonlyObservableArray, ObservableValue } from "VSS/Core/Observable";
import { getTabs } from "VSS/Features/PlatformUI/ContributedTab";
import { css, IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { ISettingsService, SettingsUserScope } from "VSS/Platform/Settings";
import { IVssContributedTab, TabBar, TabContent, TabProvider } from "VSSUI/Tabs";

interface IMyWorkComponentProps {
    className?: string;
    onDismiss?: () => void;
}

class MyWorkComponent extends VssComponent<IMyWorkComponentProps, {}> {
    private static readonly DefaultPivotStorageKey: string = "navigation/myworkdefaultpivot";
    private static _defaultTabKey: string | undefined;
    public static readonly componentType = "vertical-header-my-work-flyout";

    private _selectedTabId: ObservableValue<string>;
    private _tabs: IReadonlyObservableArray<IVssContributedTab>;

    public constructor(props: IMyWorkComponentProps, context: IVssComponentContext) {
        super(props, context);

        this._tabs = getTabs(context.pageContext, "ms.vss-tfs-web.my-work-pivot");

        if (!MyWorkComponent._defaultTabKey) {
            const settingsService = context.pageContext.getService<ISettingsService>("ISettingsService");
            MyWorkComponent._defaultTabKey = settingsService.getEntry(MyWorkComponent.DefaultPivotStorageKey, SettingsUserScope.Me);
        }

        this._selectedTabId = new ObservableValue<string>(MyWorkComponent._defaultTabKey || "work-items");
    }

    public render(): JSX.Element {
        return (
            <div className={css("flex-column flex-grow scroll-hidden", this.props.className)}>
                <TabProvider selectedTabId={this._selectedTabId} providers={this._tabs}>
                    <TabBar className="flyout-my-work-tabs" onSelectedTabChanged={this._onTabClicked} disableSticky={true} />
                    <TabContent />
                </TabProvider>
            </div>
        );
    }

    private _onTabClicked = (newTabId: string): void => {
        MyWorkComponent._defaultTabKey = newTabId;
        const settingsService = this.context.pageContext.getService<ISettingsService>("ISettingsService");
        settingsService.setEntries({ [MyWorkComponent.DefaultPivotStorageKey]: newTabId }, SettingsUserScope.Me);

        this._selectedTabId.value = newTabId;
    };
}

VssComponent.register(MyWorkComponent.componentType, MyWorkComponent);
